/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import {
  getLoadCartMarketPlaceAction,
  getLicensesToAssignAction,
  setManualErrorAction,
  getPaymentResultAction,
  TransactionPaymentStatusMarketAction,
} from '../../../actions/license.action';
import { getTokenExternalSourceAction, getParametersMarketAction } from '../../../actions/general.action';
import Loading from '../Crosscutting/Loading';
import Error from '../Error';
import Header from '../Header';

const MasterPage = ({
  component: Component, container, isAssignment, ...props
}) => {
  const theme = useTheme();
  const {
    getLoadCartMarketPlace, location, getCartError, getTokenExternalSource, getParametersMarket,
    getLicensesToAssign, tenant, setManualError, marketContext, hasResult, getPaymentResult,
    transactionPaymentStatusMarket,
  } = props;

  const [paramsError, setParamsError] = React.useState(false);
  const [isChildReady, setIsChildReady] = React.useState(false);
  const [isHeaderReady, setIsHeaderReady] = React.useState(false);
  const [loadingViewMore, setLoadingViewMore] = React.useState(false);

  const params = new URLSearchParams(location.search);
  const code = params.get('code');

  useEffect(() => {
    const initializeData = async () => {
      await getTokenExternalSource();
      await getParametersMarket('', 'ParametersMarketPlace');
      if (!code) {
        setParamsError(true);
        setManualError(tenant);
      } else {
        setParamsError(false);
        if (!isAssignment) {
          await getLoadCartMarketPlace(code, tenant);
        }
        if (isAssignment && !hasResult) {
          await getLicensesToAssign(code, tenant);
        }
        if (hasResult) {
          await transactionPaymentStatusMarket('0', 'APROBADO', code);
          getPaymentResult(tenant, code);
        }
      }
    };
    initializeData();
  }, [code]);

  const everythingIsReady = isHeaderReady && isChildReady;

  if (paramsError || getCartError) {
    return (
      <>
        {!isHeaderReady && <Loading />}
        <Box style={{ backgroundColor: theme.body.backgroundColor, minHeight: '100vh', display: isHeaderReady ? 'block' : 'none' }}>
          <Header isAssignment marketContext={marketContext} tenant={tenant} onHeaderReady={() => setIsHeaderReady(true)} code={code} />
          <Error />
        </Box>
      </>
    );
  }

  return (
    <>
      {!everythingIsReady && <Loading />}
      <Box style={{
        backgroundColor: theme.body.backgroundColor,
        minHeight: '100vh',
        maxWidth: '100vw',
        display: everythingIsReady ? 'block' : 'none',
      }}
      >
        <Header isAssignment={isAssignment} marketContext={marketContext} tenant={tenant} onHeaderReady={() => setIsHeaderReady(true)} code={code} loadingViewMore={loadingViewMore} />
        <Component {...props} code={code} onReady={() => setIsChildReady(true)} loadingViewMore={loadingViewMore} setLoadingViewMore={setLoadingViewMore} />
      </Box>
    </>
  );
};
const mapStateToProps = (props) => ({
  getCartError: props.license.getCartError,
  marketContext: props.license.marketContext,
});

const mapDispatchToProps = {
  getLoadCartMarketPlace: getLoadCartMarketPlaceAction,
  getTokenExternalSource: getTokenExternalSourceAction,
  getParametersMarket: getParametersMarketAction,
  getLicensesToAssign: getLicensesToAssignAction,
  getPaymentResult: getPaymentResultAction,
  setManualError: setManualErrorAction,
  transactionPaymentStatusMarket: TransactionPaymentStatusMarketAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(MasterPage);
